export default __webpack_public_path__ + "static/meldrum-foundation-logo-480bb1fc4af6bdf1adc08e49f25dfda4.png";